module.exports = __webpack_public_path__ + "static/media/intro-photowall-3.0db1c8ad.jpg";